<template>
  <div class="tpage">
    <div class="hero">
      <div class="brand">数智秦徐</div>
      <div class="sub">教师端</div>
    </div>

    <div class="card">
      <h3 class="card-title">教师登录</h3>
      <el-form @submit.native.prevent>
        <el-form-item>
          <el-input v-model.trim="form.tele" maxlength="11" placeholder="手机号" prefix-icon="el-icon-mobile-phone"
                    @keyup.enter.native="doLogin"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" type="password" show-password placeholder="密码"
                    prefix-icon="el-icon-lock" @keyup.enter.native="doLogin"></el-input>
        </el-form-item>
        <el-button type="primary" class="block-btn" :loading="loading" @click="doLogin">登 录</el-button>
      </el-form>

      <p class="tip">账号为学校登记的教师手机号，密码与小程序一致；忘记密码请联系教务处重置。</p>
    </div>

    <p class="footer">数智秦徐 · 教师网页端</p>
  </div>
</template>

<script>
import { teacherLogin, setTeacherLogin, getTeacherLogin } from '@/api/teacher.js'

export default {
  name: 'TeacherLogin',
  data() {
    return {
      loading: false,
      form: { tele: '', password: '' }
    }
  },
  mounted() {
    const info = getTeacherLogin()
    if (info && info.token) {
      // 已登录直接进功能页
      this.$router.replace('/thome')
    }
  },
  methods: {
    doLogin() {
      if (!this.form.tele) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!/^1\d{10}$/.test(this.form.tele)) {
        this.$message.warning('手机号格式不正确')
        return
      }
      if (!this.form.password) {
        this.$message.warning('请输入密码')
        return
      }
      this.loading = true
      teacherLogin({ tele: this.form.tele, password: this.form.password })
        .then((res) => {
          this.loading = false
          if (res.code !== 0) {
            this.$message.error(res.msg || '登录失败')
            return
          }
          setTeacherLogin(res.data)
          this.$message.success('登录成功')
          this.$router.replace('/thome')
        })
        .catch(() => {
          this.loading = false
          this.$message.error('网络异常，请稍后重试')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
  padding-bottom: 40px;
}
.hero {
  background: linear-gradient(135deg, #3b6ef0, #5b8cff);
  color: #fff;
  padding: 44px 24px 72px;
  text-align: center;
  .brand {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 4px;
  }
  .sub {
    margin-top: 6px;
    font-size: 13px;
    opacity: 0.85;
    letter-spacing: 2px;
  }
}
.card {
  max-width: 420px;
  width: calc(100% - 32px); /* 手机端不超出屏幕 */
  box-sizing: border-box; /* 关键：让 padding 算在宽度内，否则右边被裁 */
  margin: -44px auto 0;
  background: #fff;
  border-radius: 12px;
  padding: 22px 20px 8px;
  box-shadow: 0 6px 24px rgba(59, 110, 240, 0.12);

  .card-title {
    margin: 0 0 18px;
    font-size: 17px;
    color: #1f2d3d;
  }
}
.block-btn {
  width: 100%;
  height: 42px;
  font-size: 15px;
}
.tip {
  margin: 14px 0 10px;
  font-size: 12px;
  color: #8a94a6;
  line-height: 1.6;
}
.footer {
  text-align: center;
  color: #a8b0c0;
  font-size: 12px;
  margin-top: 22px;
}
</style>
